import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RightPanel from "@/components/RightPanel";
import { AppMain, Navbar, Settings, Sidebar, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";
import { webConfig } from "@/api/public/public";
import { industryListAll, industryCategory, projectLevel, resourceType, professionalResourceLibraryType, courseLevel, yearListAll, applicationType, mediaType, courseSource, getMatchMajorListAll } from "@/api/beforeMen/beforeMen";
import { courseProjectListAll, videoTypeListAll } from "@/api/openVideo/openVideo";
import { typeListAll, nameListAll } from "@/api/competitionColumn/competitionColumn";
export default {
  name: "Layout",
  components: {
    AppMain: AppMain,
    Navbar: Navbar,
    RightPanel: RightPanel,
    Settings: Settings,
    Sidebar: Sidebar,
    TagsView: TagsView
  },
  mixins: [ResizeMixin],
  computed: _objectSpread(_objectSpread({}, mapState({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    showSettings: function showSettings(state) {
      return state.settings.showSettings;
    },
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    },
    fixedHeader: function fixedHeader(state) {
      return state.settings.fixedHeader;
    },
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    }
  }),
  data: function data() {
    return {
      provinceId: this.$store.getters.provinceId,
      hdImg: "",
      // userInfo: {
      //   img: require("@/assets/img/userHD.png"),
      //   name: "唐牛才是食神",
      //   border: require("@/assets/img/border.jpg")
      // }
      zwt: require("@/assets/img/user.png")
    };
  },
  methods: {
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", {
        withoutAnimation: false
      });
    },
    fn: function fn() {
      console.log(1111);
    },
    isTo: function isTo() {
      this.$router.push("/userInfoSet/userHdChange");
    },
    logout: function logout(e) {
      var u = JSON.parse(localStorage.getItem("wShoolInfo"));
      var v = JSON.parse(sessionStorage.getItem("info"));
      if (e === 1) {
        if (this.$store.getters.wCode && v.roleType == 3) {
          this.$router.push("/".concat(u.uniqueCode));
        } else {
          localStorage.setItem("hdColor", 0);
          this.$router.push("/");
        }
      } else if (e === 2) {
        if (this.$store.getters.wCode && v.roleType == 3) {
          return this.$store.dispatch("user/logout");
        } else {
          return this.$store.dispatch("user/logout");
        }
      }
    },
    // 获取网站标题logo,文字描述
    getWebLogo: function getWebLogo() {
      var _this = this;
      webConfig({
        param: this.prCode
      }).then(function (res) {
        var data = res.data;
        _this.hdImg = data.adminLogo;
      });
    },
    // 获取课程来源
    getCourseSource: function getCourseSource() {
      var _this2 = this;
      courseSource({
        provinceId: this.provinceId
      }).then(function (res) {
        for (var i in res.data) {
          _this2.$set(res.data[i], "value", res.data[i].id);
        }
        _this2.$store.commit('settings/getwCourseSource', res.data);
      });
    },
    // 获取产业分类
    getIndustry: function getIndustry() {
      var _this3 = this;
      industryListAll({
        name: "",
        pageNum: 1,
        pageSize: 1000,
        provinceId: ""
      }).then(function (res) {
        _this3.$store.commit('settings/getwIndustryType', res.rows);
        // console.log('产业分类2',this.$store.getters.wIndustryType)
      });
    },
    // 获取行业门类
    getIndustryCategory: function getIndustryCategory() {
      var _this4 = this;
      industryCategory({
        name: "",
        pageNum: 1,
        pageSize: 1000,
        provinceId: ""
      }).then(function (res) {
        // for(let i in res.data){
        //   res.data[i].name = res.data[i].remark + res.data[i].name
        // }
        _this4.$store.commit('settings/getwIndustryCategory', res.rows);
        // console.log('行业门类',this.$store.getters.wIndustryCategory)
      });
    },
    // 获取项目级别
    getProjectLevel: function getProjectLevel() {
      var _this5 = this;
      projectLevel({
        name: "",
        pageNum: 1,
        pageSize: 1000,
        provinceId: ""
      }).then(function (res) {
        for (var i in res.data) {
          _this5.$set(res.data[i], "value", res.data[i].id);
        }
        _this5.$store.commit('settings/getwProjectLevel', res.rows);
      });
    },
    // 获取资源库类型
    getResourceType: function getResourceType() {
      var _this6 = this;
      resourceType({
        provinceId: this.provinceId
      }).then(function (res) {
        _this6.$store.commit('settings/getwResourceType', res.data);
      });
    },
    // 获取资源库分类
    getProfessionalResourceLibraryType: function getProfessionalResourceLibraryType() {
      var _this7 = this;
      professionalResourceLibraryType({
        provinceId: this.provinceId
      }).then(function (res) {
        _this7.$store.commit('settings/getwProfessionalResourceLibraryType', res.data);
      });
    },
    // 获取层次管理
    getCourseLevel: function getCourseLevel() {
      var _this8 = this;
      courseLevel({
        name: "",
        pageNum: 1,
        pageSize: 1000,
        provinceId: ""
      }).then(function (res) {
        _this8.$store.commit('settings/getwCourseLevel', res.rows);
      });
    },
    // 获取层次管理
    getYearListAll: function getYearListAll() {
      var _this9 = this;
      yearListAll({
        name: "",
        pageNum: 1,
        pageSize: 1000,
        provinceId: ""
      }).then(function (res) {
        _this9.$store.commit('settings/getwYearListAll', res.data);
      });
    },
    // 获取应用类型
    getApplicationType: function getApplicationType() {
      var _this0 = this;
      applicationType({
        provinceId: this.provinceId
      }).then(function (res) {
        _this0.$store.commit('settings/getwApplicationType', res.data);
      });
    },
    // 获取媒体类型
    getMediaType: function getMediaType() {
      var _this1 = this;
      mediaType({
        provinceId: this.provinceId
      }).then(function (res) {
        _this1.$store.commit('settings/getwMediaType', res.data);
      });
    },
    // 获取专业大类
    getMajor: function getMajor() {
      var _this10 = this;
      getMatchMajorListAll({
        businessId: "",
        parentId: '0'
      }).then(function (res) {
        if (res.code === 2000) {
          _this10.$store.commit('settings/getwMajorListAll', res.data);
          console.log('专业大类', _this10.$store.getters.wMajorListAll);
        }
      });
    },
    // 获取数字课程项目管理
    getwDigitalCourse: function getwDigitalCourse() {
      var _this11 = this;
      courseProjectListAll({
        provinceId: this.provinceId
      }).then(function (res) {
        _this11.$store.commit('settings/getwDigitalCourse', res.data);
      });
    },
    // 获取视频分类管理
    getwVideoClassification: function getwVideoClassification() {
      var _this12 = this;
      videoTypeListAll({
        provinceId: this.provinceId
      }).then(function (res) {
        _this12.$store.commit('settings/getwVideoClassification', res.data);
      });
    },
    // 获取比赛类型
    getwContestType: function getwContestType() {
      var _this13 = this;
      typeListAll({
        provinceId: this.provinceId
      }).then(function (res) {
        _this13.$store.commit('settings/getwContestType', res.data);
      });
    },
    // 获取比赛名称
    getwContestName: function getwContestName() {
      var _this14 = this;
      nameListAll({
        provinceId: this.provinceId
      }).then(function (res) {
        _this14.$store.commit('settings/getwContestName', res.data);
      });
    }
  },
  created: function created() {
    // this.getWebLogo();

    this.getIndustry();
    this.getIndustryCategory();
    // this.getProjectLevel()
    // this.getResourceType()
    // this.getProfessionalResourceLibraryType()
    this.getCourseLevel();
    this.getYearListAll();
    // this.getApplicationType()
    // this.getMediaType()
    // this.getCourseSource()
    // this.getMajor()
    // this.getwDigitalCourse()
    // this.getwVideoClassification()
    // this.getwContestType()
    // this.getwContestName()
  }
};